export const checkEmailValid = (email) => {
  if (!email) return false;

  // 1. Không chứa dấu tiếng Việt có dấu (unicode với dấu)
  const vietnameseAccentsRegex =
    /[àáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ]/i;
  if (vietnameseAccentsRegex.test(email)) {
    return false;
  }

  // 2. Không chứa dấu câu đặc biệt không hợp lệ (trừ @ và .)
  const punctuationRegex = /[!#$%^&*()+={}\[\]|:;"'<>,?/\\~`]/;
  if (punctuationRegex.test(email)) {
    return false;
  }

  // 3. Kiểm tra định dạng email chuẩn
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email.toLowerCase());
};
